import { render, staticRenderFns } from "./mv-wd-account.vue?vue&type=template&id=f9c6b3b4&scoped=true"
import script from "./mv-wd-account.vue?vue&type=script&lang=js"
export * from "./mv-wd-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c6b3b4",
  null
  
)

export default component.exports